// extracted by mini-css-extract-plugin
export default {"grid-announcement":"GridAnnouncement_grid-announcement__UiyBQ","grid-announcement-help-icon":"GridAnnouncement_grid-announcement-help-icon__pd4yq"};